import { render, staticRenderFns } from "./deleteCouponPropertyPoolDetail.vue?vue&type=template&id=5a82d860&scoped=true"
import script from "./deleteCouponPropertyPoolDetail.vue?vue&type=script&lang=js"
export * from "./deleteCouponPropertyPoolDetail.vue?vue&type=script&lang=js"
import style0 from "./deleteCouponPropertyPoolDetail.vue?vue&type=style&index=0&id=5a82d860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a82d860",
  null
  
)

export default component.exports